import { ReactElement, ReactNode, useId } from 'react';
import { Tooltip } from 'react-tooltip';
import { charcoal } from '../../styles';
import { UIText } from '../ui-text';

type UITooltipPlace =
    | 'top'
    | 'top-start'
    | 'top-end'
    | 'right'
    | 'right-start'
    | 'right-end'
    | 'bottom'
    | 'bottom-start'
    | 'bottom-end'
    | 'left'
    | 'left-start'
    | 'left-end';
type UITooltipProps = {
    children?: ReactNode;
    text: string;
    place?: UITooltipPlace;
    style?: React.CSSProperties;
    /**
     * Attach the tooltip to an element that already exists, by its id, instead
     * of wrapping children in one. For hover targets that cannot take a wrapper
     * — a whole table row, say — put this id on the element and render the
     * tooltip with no children.
     */
    anchorId?: string;
};

export function UITooltip(props: UITooltipProps): ReactElement {
    const { children, text, place = 'top', style, anchorId } = props;

    const generatedId = `tooltip-${useId()}`;
    const id = anchorId ?? generatedId;
    const anchorSelect = `#${id}`;
    return (
        <>
            {!anchorId && (
                <a id={id} style={style}>
                    {children}
                </a>
            )}
            <Tooltip
                anchorSelect={anchorSelect}
                place={place}
                style={{
                    backgroundColor: charcoal,
                    borderRadius: 8
                }}
            >
                <UIText type="white" variant="small">
                    {text}
                </UIText>
            </Tooltip>
        </>
    );
}
